import React from 'react'

const Error = ({ errorMessage }) => {
    return (
        <div>
            <div className="bg-red-900 bg-opacity-50 border border-red-500 text-red-500 px-4 py-3 rounded-lg relative text-start" role="alert">
                <div className="text-base font-bold mb-1"><i className="bi bi-exclamation-triangle-fill me-2"></i> Errors</div>
                <div className="text-sm text-white">{errorMessage}</div>
            </div>
        </div>
    )
}

export default Error